import * as Yup from 'yup';
import { Copy } from '../copy/Copy';
import { validateYoutubeId } from '../helpers/validateYoutubeId';
import { getYoutubeId } from '../helpers/getYoutubeId';

Yup.addMethod(Yup.string, 'validateYoutubeId', function (errorMessage) {
  return this.test('validate-youtube-id', errorMessage, async function (value) {
    const { path, createError } = this;

    const videoId = getYoutubeId(value);

    return (
      (await validateYoutubeId(videoId)) ||
      createError({ path, message: errorMessage })
    );
  });
});

export const ADD_VIDEO_VALIDATION_SCHEMA = Yup.object({
  youtubeUrl: Yup.string()
    .min(1, Copy.generate('Errors.videoId'))
    .validateYoutubeId(Copy.generate('Errors.invalidYoutubeUrl'))
    .required(Copy.generate('Errors.required')),
});
